'use client';

import Script, { ScriptProps } from 'next/script';

type Props = {
  id: string;
  code: string;
  when?: boolean; // optional gate
  strategy?: ScriptProps['strategy']; // afterInteractive | lazyOnload | beforeInteractive
};

const InlineScript = ({ id, code, when = true, strategy = 'afterInteractive' }: Props) => {
  if (!when) return null;

  return <Script id={id} strategy={strategy} dangerouslySetInnerHTML={{ __html: code }} />;
};

export default InlineScript;
